export const servicePointServices = [
  'otc',
  'printless',
  'spa',
  'firstmile',
  'lastmile',
  'selfservice',
  'not-home-to-sp',
  'consumer-interventions',
] as const
